import PropTypes from 'prop-types';
import { defaultProps as defaultProps$1 } from '../Toast/Toast.types.js';

var propTypes = {
    containerId: PropTypes.string,
    limit: PropTypes.number,
    stylePosition: PropTypes.string,
};
var defaultProps = {
    containerId: defaultProps$1.containerId,
    position: defaultProps$1.position,
    stylePosition: 'fixed',
};

export { defaultProps, propTypes };
